"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCredentials = void 0;
var axios_1 = __importDefault(require("axios"));
var UserCredentials = (function () {
    function UserCredentials(token, profileId) {
        this.baseUrl = process.env.EDULAR_CORE_API_BASE_URL;
        this.token = token;
        this.profileId = profileId;
    }
    UserCredentials.prototype.createUserEducationalBackground = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-educational-background/create");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.createUserCertification = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-certification/create");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.createUserProfessionalExperience = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-professional-experience/create");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_3 = _a.sent();
                        console.log(error_3);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.createUserServiceSessionsAttended = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-service-sessions-attended/create");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_4 = _a.sent();
                        console.log(error_4);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.createUserProfessionalEducationalDevelopment = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-professional-educational-development/create");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_5 = _a.sent();
                        console.log(error_5);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.getUserEducationalBackgroundList = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-educational-background/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_6 = _a.sent();
                        console.log(error_6);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.getUserCertificationList = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-certification/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_7 = _a.sent();
                        console.log(error_7);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.getUserProfessionalExperienceList = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-professional-experience/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_8 = _a.sent();
                        console.log(error_8);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.getUserServiceSessionsAttendedList = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-service-sessions-attended/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_9 = _a.sent();
                        console.log(error_9);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.getUserProfessionalEducationalDevelopmentList = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-professional-educational-development/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_10 = _a.sent();
                        console.log(error_10);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.updateUserEducationalBackground = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-educational-background/edit");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_11 = _a.sent();
                        console.log(error_11);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.updateUserCertification = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-certification/edit");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_12 = _a.sent();
                        console.log(error_12);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.updateUserProfessionalExperience = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-professional-experience/edit");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_13 = _a.sent();
                        console.log(error_13);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.updateUserServiceSessionsAttended = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-service-sessions-attended/edit");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_14 = _a.sent();
                        console.log(error_14);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    UserCredentials.prototype.updateUserProfessionalEducationalDevelopment = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/user-professional-educational-development/edit");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_15 = _a.sent();
                        console.log(error_15);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    return UserCredentials;
}());
exports.UserCredentials = UserCredentials;
//# sourceMappingURL=data:application/json;base64,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